import script from "./ValidationField.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationField.vue?vue&type=script&setup=true&lang=js"

import "./ValidationField.vue?vue&type=style&index=0&id=446d2642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446d2642"]])

export default __exports__